import React from 'react';
import { Pipette } from 'lucide-react';
import { Popover, PopoverTrigger, PopoverContent } from './popover';
import { Button } from './button';
import { Input } from './input';
import { Label } from './label';

const ColorPicker = ({ value, onChange, label }) => (
  <div className="flex flex-col gap-1.5">
    {label && <Label>{label}</Label>}
    <div className="flex items-center gap-2">
      <Popover>
        <PopoverTrigger asChild>
          <Button variant="outline" size="icon" className="shrink-0 p-0.5">
            <span
              className="size-full rounded-[4px] ring-1 ring-inset ring-black/10"
              style={{ backgroundColor: value }}
            />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-3" align="start" sideOffset={8}>
          <div className="flex flex-col gap-3">
            <input
              type="color"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              className="size-48 cursor-pointer border-0 p-0 rounded-md"
            />
            <div className="flex items-center gap-2">
              <Pipette className="text-muted-foreground shrink-0" />
              <Input
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="font-mono text-center h-8"
                maxLength={7}
              />
            </div>
          </div>
        </PopoverContent>
      </Popover>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="font-mono"
        maxLength={7}
      />
    </div>
  </div>
);

export { ColorPicker };
